<template>
  <div
    class="py-4 container-fluid min-vh-100 top20-page"
    :class="isDarkMode ? 'top20-page-dark' : 'bg-light-moniex'"
    :style="isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="top20-hero-banner mb-3"
      :style="isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="top20-hero-content">
        <h1
          :style="isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Top 20 hráčů</h1>
        <p :style="isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">
          Tři pohledy na stejná data — férový výnos, celkový výnos i žebříček podle počtu her.
        </p>
      </div>
    </div>

    <div class="row align-items-start">
      <div class="col-12 col-lg-4 mb-4">
        <div
          class="border-0 shadow-sm rounded-4 overflow-hidden p-3 h-100"
          :style="surfaceStyle"
        >
          <div class="d-flex flex-wrap justify-content-between align-items-end gap-2 mb-3 px-1">
            <h5 class="mb-0 table-title">Nejlepší výnos celkově</h5>
            <span class="table-hint">I z jedné hry</span>
          </div>
          <top20-table :rows="byYieldAll" show-game-count compact />
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-4">
        <div
          class="border-0 shadow-sm rounded-4 overflow-hidden p-3 mb-2"
          :style="surfaceStyle"
        >
          <div class="d-flex flex-wrap justify-content-between align-items-end gap-2 mb-2 px-1">
            <h5 class="mb-0 table-title">Nejlepší výnos</h5>
            <span class="table-hint">Nejméně {{ minGames }} dohrané hry</span>
          </div>
          <top20-table :rows="byYield" show-game-count :compact="1" />
        </div>
        <div
          class="border-0 shadow-sm rounded-4 overflow-hidden p-3"
          :style="surfaceStyle"
        >
          <div class="d-flex flex-wrap justify-content-between align-items-end gap-2 mb-2 px-1">
            <h5 class="mb-0 table-title">Nejvíc her</h5>
            <span class="table-hint">Podle počtu dohraných her</span>
          </div>
          <top20-table :rows="byGames" show-game-count :compact="1" />
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-4">
        <ActiveGamesSidebar />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import Top20Table from "./components/custom/tables/Top20Table.vue";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const players = ref([]);
const minGames = 3;

const yieldValue = (row) => Number(row.Yield ?? row.z ?? 0);
const gameCount = (row) => Number(row.GameCount ?? row.Count ?? 0);

const byYield = computed(() => {
  return [...players.value]
    .filter((row) => gameCount(row) >= minGames)
    .sort((a, b) => yieldValue(b) - yieldValue(a) || gameCount(b) - gameCount(a))
    .slice(0, 10);
});

const byYieldAll = computed(() => {
  return [...players.value]
    .sort((a, b) => yieldValue(b) - yieldValue(a) || gameCount(b) - gameCount(a))
    .slice(0, 20);
});

const byGames = computed(() => {
  return [...players.value]
    .sort((a, b) => gameCount(b) - gameCount(a) || yieldValue(b) - yieldValue(a))
    .slice(0, 10);
});

const surfaceStyle = computed(() => {
  if (store.state.isDarkMode) {
    return "background: #0F172A !important; background-color: #0F172A !important; border: 1px solid #334155 !important; border-radius: 0.65rem !important;";
  }
  return "background: #ffffff; border: 1px solid transparent; border-radius: 0.65rem !important;";
});

const fetchTop20 = async () => {
  const data = await dataService.GetTop20();
  players.value = Array.isArray(data) ? data : [];
};

fetchTop20();
</script>

<style scoped>
.top20-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.top20-hero-content h1 {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}

.top20-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

.table-title {
  font-weight: 800;
  color: #0F172A;
}

.top20-page-dark .table-title {
  color: #E2E8F0;
}

.table-hint {
  font-size: 0.78rem;
  font-weight: 600;
  color: #64748B;
}

.top20-page-dark .table-hint {
  color: #94A3B8;
}

.bg-light-moniex {
  background-color: #f8f9fa;
}

.top20-page-dark :deep(.vgt-inner-wrap),
.top20-page-dark :deep(.vgt-responsive),
.top20-page-dark :deep(.vgt-wrap) {
  background: transparent !important;
  box-shadow: none !important;
}

.top20-page-dark :deep(.vgt-table) {
  background: transparent !important;
  color: #E2E8F0 !important;
  border: none !important;
}

.top20-page-dark :deep(.vgt-table th) {
  background: #1E293B !important;
  color: #94A3B8 !important;
  border-color: #334155 !important;
}

.top20-page-dark :deep(.vgt-table td) {
  background: transparent !important;
  color: #E2E8F0 !important;
  border-color: #334155 !important;
}

.top20-page :deep(.vgt-table tbody tr:last-child td),
.top20-page-dark :deep(.vgt-table tbody tr:last-child td) {
  border-bottom: none !important;
}

.top20-page-dark :deep(.vgt-table tbody tr:hover),
.top20-page-dark :deep(.vgt-table tr.clickable:hover) {
  background-color: #1E293B !important;
  cursor: pointer;
}

.top20-page-dark :deep(.text-dark) {
  color: #E2E8F0 !important;
}
</style>
